import { colors, flex } from '@ebh/capsule/theme';
import { css } from '@emotion/react';

export default {
  container: css`
    ${[
      flex('center', 'column'),
      {
        height: '100vh',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    ]}
  `,
  spinner: css`
    ${{ color: colors['primary-400'] }}
  `,
};
